import { render, staticRenderFns } from "./ProductImport.vue?vue&type=template&id=b2eed840&scoped=true"
import script from "./ProductImport.vue?vue&type=script&lang=js"
export * from "./ProductImport.vue?vue&type=script&lang=js"
import style0 from "./ProductImport.vue?vue&type=style&index=0&id=b2eed840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eed840",
  null
  
)

export default component.exports